module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/464.73f64cbf.png";